export default __webpack_public_path__ + "static/media/hingo-screenshot-02.2f047664.png";